export default __webpack_public_path__ + "static/media/Caring.0134ccb3.png";